module.exports = __webpack_public_path__ + "static/img/9.073bcc8e.jpg";